export class UpdatePasswordRegisterResult {
  isOk: boolean;
  isCurrentPasswordInvalid: boolean;
}
